/**
 * Convert time in minutes since midnight to display format
 * @param {number} time - Minutes since midnight (0-1439)
 * @param {string} lang - User's favorite language ('en' for 12h format, else 24h)
 * @returns {string} Formatted time string
 */
export function displayTime(time, lang = 'en') {
  const hours = Math.floor(time / 60);
  const minutes = time % 60;

  if (lang === 'en') {
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
